import type { Theme } from "@mui/material/styles";

const styles = (theme: Theme) => ({
  multiline: {
    "& .MuiInputBase-input": {
      height: "85px !important",
    },
    "& .MuiOutlinedInput-root": {
      height: "auto",
      minHeight: 50,
      padding: "0.5rem",
    },
  },
  readOnly: {
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: `${theme.palette.action.disabled} !important`,
        borderWidth: "1px !important",
      },
      "&:hover fieldset": {
        borderColor: `${theme.palette.action.disabled} !important`,
        borderWidth: "1px !important",
      },
      "&.Mui-focused fieldset": {
        borderColor: `${theme.palette.action.disabled} !important`,
        borderWidth: "1px !important",
      },
      "&.MuiInputBase-multiline fieldset": {
        borderColor: `${theme.palette.action.disabled} !important`,
        borderWidth: "1px !important",
      },
      "&.MuiInputBase-multiline:hover fieldset": {
        borderColor: `${theme.palette.action.disabled} !important`,
        borderWidth: "1px !important",
      },
      "&.MuiInputBase-multiline.Mui-focused fieldset": {
        borderColor: `${theme.palette.action.disabled} !important`,
        borderWidth: "1px !important",
      },
    },
    "& .MuiInputBase-input, & .MuiInputBase-inputMultiline, & textarea": {
      cursor: "not-allowed",
      color: `${theme.palette.text.primary} !important`,
      WebkitTextFillColor: `${theme.palette.text.primary} !important`,
    },
  },
  counter: {
    margin: "0 1px 0 auto",
    fontSize: 12,
  },
  holder: {
    display: "flex",
    justifyContent: "space-between",
    margin: "auto",
  },
  textField: {
    "& .MuiFormHelperText-root": {
      marginLeft: 0,
      marginRight: 0,
    },
  },
});

export default styles;
